export * from './lib/assets.module';

export * from './lib/components/icon/icon.component';

export * from './lib/generated/generated-icons';

export * from './lib/pipes/env-based-asset-path.pipe';

export * from './lib/services/assets.service';
